"use strict";
/**
 * @file Created on 05.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var NThresholdSystemVolumeDTO_1 = require("../model/NThresholdSystemVolumeDTO");

var NotificationDocConverter_1 = require("../NotificationDocConverter");

var NThresholdSystemVolumeConverterImpl_1 = require("./NThresholdSystemVolumeConverterImpl");

var NThresholdSystemVolumeDTOConverter_1 = require("./NThresholdSystemVolumeDTOConverter");
/**
 * @author Tomas Leity
 */


var NThresholdSystemVolumeDTOConverterImpl =
/*#__PURE__*/
function (_NThresholdSystemVolu) {
  _inherits(NThresholdSystemVolumeDTOConverterImpl, _NThresholdSystemVolu);

  /**
   * @param productObjectConverter
   */
  function NThresholdSystemVolumeDTOConverterImpl(productObjectConverter) {
    var _this;

    _classCallCheck(this, NThresholdSystemVolumeDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NThresholdSystemVolumeDTOConverterImpl).call(this));
    _this.productObjectConverter = productObjectConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NThresholdSystemVolumeDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new NThresholdSystemVolumeDTO_1.NThresholdSystemVolumeDTO(NThresholdSystemVolumeDTO_1.NThresholdSystemVolumeDTO.schema.products.valueOf(conversions.asObjectList(source, 'products', function (obj) {
        return _this2.productObjectConverter.toObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        products: conversions.asObjectArray(source, 'products', function (obj) {
          return _this3.productObjectConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
  }]);

  return NThresholdSystemVolumeDTOConverterImpl;
}(NThresholdSystemVolumeDTOConverter_1.NThresholdSystemVolumeDTOConverter);
/**
 * IOC Container qualifier
 */


NThresholdSystemVolumeDTOConverterImpl.QUALIFIER = {
  documentType: NThresholdSystemVolumeDTO_1.NThresholdSystemVolumeDTO.name
};
NThresholdSystemVolumeDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject(NThresholdSystemVolumeConverterImpl_1.NThresholdSystemVolumeConverterImpl.QUALIFIER)), __metadata("design:paramtypes", [NotificationDocConverter_1.NotificationDocConverter])], NThresholdSystemVolumeDTOConverterImpl);
exports.NThresholdSystemVolumeDTOConverterImpl = NThresholdSystemVolumeDTOConverterImpl;